import { useSubscriptionContext } from '../../../contexts/SubscriptionContext';
import { Btn } from '../../ui';

export const TrialBanner = () => {
    const { trialDaysRemaining } = useSubscriptionContext();

    if (trialDaysRemaining === null) return null;

    const isUrgent = trialDaysRemaining <= 3;

    return (
        <div className={`trial-banner ${isUrgent ? 'trial-banner--urgent' : ''}`}>
            <div className="trial-banner-content">
                <span className="trial-banner-icon">{isUrgent ? '⚠️' : 'ℹ️'}</span>
                <div className="trial-banner-text">
                    <strong>Your free demo ends in {trialDaysRemaining} day{trialDaysRemaining !== 1 ? 's' : ''}</strong>
                    <span className="trial-banner-subtext">
                        You currently have full access to everything. After your demo, subscribe to the Core Program to keep your data, then add premium modules as needed.
                    </span>
                </div>
            </div>
            <div className="trial-banner-actions">
                <span className="trial-banner-countdown">{trialDaysRemaining} DAYS LEFT</span>
                <Btn
                    variant="primary"
                    buttonSize="sm"
                    buttonText="Choose a Plan →"
                    buttonOnClick={() => {/* TODO: scroll to compare plans or open checkout */ }}
                />
            </div>
        </div>
    );
};
